export const TwentyFourHourIcon = (
  <svg
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge"
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
    <text
      x="50%"
      y="50%"
      dominantBaseline="middle"
      textAnchor="middle"
      style={{ fontSize: '7px', fontWeight: 900 }}
    >
      24h
    </text>
  </svg>
);

export const SearchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M379.51-323q-105.12 0-179.08-73.96-73.95-73.95-73.95-179.04 0-105.09 73.95-179.04Q274.39-829 379.48-829q105.09 0 179.04 73.96 73.96 73.95 73.96 179.07 0 41.52-11.37 76.46-11.37 34.94-31.11 63.81l209.48 210.05q14.96 15.52 14.96 34.32 0 18.81-15.53 33.77-14.95 14.95-34.54 14.95t-34.54-14.95L520.91-365.48q-29.43 19.74-64.94 31.11Q420.46-323 379.51-323Zm-.03-98q64.91 0 109.95-45.04 45.05-45.05 45.05-109.96t-45.05-109.96Q444.39-731 379.48-731t-109.96 45.04Q224.48-640.91 224.48-576t45.04 109.96Q314.57-421 379.48-421Z" />
  </svg>
);

export const ArrowLeftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="m362.78-431 59.09 59.09q14.39 14.39 14.67 34.54.29 20.15-14.19 34.54-14.87 14.4-34.74 14.11-19.87-.28-34.26-14.67l-142.57-142q-14.95-14.59-14.95-34.43 0-19.83 14.95-34.79l142.57-142q14.39-14.39 34.26-14.67 19.87-.29 34.74 14.11 14.48 14.39 14.19 34.54-.28 20.15-14.67 34.54L362.78-529h372q20.41 0 34.73 14.25 14.32 14.24 14.32 34.54 0 20.3-14.32 34.75Q755.19-431 734.78-431h-372Z" />
  </svg>
);

export default TwentyFourHourIcon;
